import { render, staticRenderFns } from "./CourseExpressCard.vue?vue&type=template&id=0579e3f3&scoped=true"
import script from "./CourseExpressCard.vue?vue&type=script&lang=js"
export * from "./CourseExpressCard.vue?vue&type=script&lang=js"
import style0 from "./CourseExpressCard.vue?vue&type=style&index=0&id=0579e3f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0579e3f3",
  null
  
)

export default component.exports